<div
  class="!tw-h-[470px] !tw-border-[2px] dark:!tw-border-[rgb(113,113,122)] tw-relative tw-p-4 tw-mb-4 !tw-border-rounded-lg"
>
  <!-- *delete btn  -->
  <button
    type="button"
    [matTooltip]="'common.delete' | translate"
    class="tw-absolute tw-top-[-20px] tw-left-[20px] tw-w-[40px] tw-h-[40px] tw-rounded-full tw-bg-rose-500 tw-flex-center tw-shadow hover:tw-bg-rose-600"
    (click)="onDeleteCard()"
  >
    <span
      class="mdi mdi-trash-can-outline !tw-text-white tw-text-[20px]"
    ></span>
  </button>

  <!-- form  -->
  <div class="tw-pt-[20px]">
    <form [formGroup]="form">
      <div class="tw-grid tw-grid-cols-1 tw-items-center !tw-p-3">
        <!-- *file name  -->
        <form-field
          [control]="form.get('title')"
          [(value)]="fileItem.title"
          (valueChange)="emitChanges()"
          label="pages.phonebookFileProgresses.fields.fileName"
          type="text"
        ></form-field>

        <!-- *file type  -->
        <enum-select-search
          enumName="HelpFileTypes"
          [control]="form.get('type')"
          [(value)]="fileItem.type"
          (valueChange)="selectFileType()"
          [isDisabled]="isUploadedFile"
          label="pages.organizations.organizationDocumentation.form.fields.organizationDocument"
        ></enum-select-search>

        <!-- *fileLink -->
        <list-group-item
          *ngIf="isUploadedFile"
          label="common.fileLink"
          marginClass="tw-mb-2"
          [value]="fileItem.filePath | addApiUrlBeforePath"
        >
        </list-group-item>

        <!-- *file uploader  -->
        <file-uploader
          #fileUploader
          *ngIf="!isUploadedFile"
          label="common.fileUpload"
          [control]="form.get('file')"
          (valueChange)="onFileChange($event)"
          [acceptFile]="allowedFileTypes.join(',')"
          [maxFileSize]="100"
          sizeType="mb"
        ></file-uploader>

        <!-- *image preview  -->
        <app-show-images
          [class.hidden]="
            isUploadedFile && fileItem.type == HelpFileTypes.Video
          "
          class="mb-3"
          [class]="isUploadedFile ? '!tw-h-[130px]' : ''"
          [imageClass]="
            fileItem.type == HelpFileTypes.File ||
            fileItem.type == HelpFileTypes.Pdf
              ? '!tw-p-6'
              : ''
          "
          [imgHeight]="isUploadedFile ? '130px' : '130px'"
          [src]="
            isUploadedFile && fileItem.type == HelpFileTypes.Image
              ? (previewFileUrl | addApiUrlBeforePath)
              : previewFileUrl
          "
          [imageType]="fileItem?.type"
        ></app-show-images>

        <!-- *video preview  -->
        <video
          *ngIf="isUploadedFile && fileItem.type == HelpFileTypes.Video"
          controls
          width="600"
          height="100"
          class="mb-3 !tw-h-[130px]"
        >
          <source
            [src]="previewFileUrl | addApiUrlBeforePath"
            type="video/mp4"
          />
        </video>
        <!-- *upload btn  -->
        <button
          *ngIf="!isUploadedFile"
          [disabled]="!file"
          type="button"
          class="tw-bg-primary-500 hover:tw-bg-primary-600 tw-text-white tw-text-lg !tw-mr-auto !tw-ml-auto tw-w-full tw-block tw-px-6 tw-py-3 tw-rounded"
          (click)="uploadFileApi()"
        >
          @if(loading){
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Loading...</span>
          } @else{
          {{ "common.fileUpload" | translate }}
          <i class="mdi mdi-22px mdi-upload-outline mx-1 !tw-text-white"></i>
          }
        </button>
        <!-- *download btn  -->
        <a
          *ngIf="isUploadedFile"
          [href]="fileItem.filePath"
          download
          target="_blank"
          class="tw-flex-center mt-2 tw-w-full tw-bg-green-500 hover:tw-bg-green-600 !tw-text-white tw-text-lg !tw-mr-auto !tw-ml-auto tw-px-6 tw-py-3 tw-rounded"
        >
          {{ "common.download" | translate }}
          <i class="mdi mdi-22px mdi-download-outline mx-1 !tw-text-white"></i>
        </a>
      </div>
    </form>
  </div>
</div>
